<div *ngIf="currentLang === 'ja'">
  <div class="manual-link">
    <a [href]="manualTopLink">使い方トップ</a> » 展示詳細情報の説明
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card class="manual-card">
      <mat-card-header>
        <mat-card-title><span>展示詳細情報の説明</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/exhibit-detail.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> 追加ボタン
        </div>
        <div class="manual-explain">
          クリックすることで追加画面が表示されます。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> 削除ボタン
        </div>
        <div class="manual-explain">
          クリックすることで選択した情報を削除します。<br>
          ボタンは、一覧の削除チェックボックスにチェックを入れる事で活性化されます。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> Filter・属性
        </div>
        <div class="manual-explain">
          展示詳細一覧に表示されているデータのフィルタリングを行います。<br>
          ※フィルタリングの対象は、ID、名称、属性（プルダウンによるフィルタリング）
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> 展示詳細一覧
        </div>
        <div class="manual-explain">
          登録済みの展示詳細情報の一覧が表示されます。<br>
          編集アイコンをクリックすることで編集画面が表示されます。<br>
        </div>

      </mat-card-content>
    </mat-card>

  </div>
</div>
<div *ngIf="currentLang === 'en'">
  <div class="manual-link">
    <a [href]="manualTopLink">User Guide Top</a> » Explanation of Exhibit Detail Information
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card class="manual-card">
      <mat-card-header>
        <mat-card-title><span>Explanation of Exhibit Detail Information</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/en_exhibit-detail.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> Add Button
        </div>
        <div class="manual-explain">
          Click to display the add screen.
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> Delete Button
        </div>
        <div class="manual-explain">
          Click to delete the selected information.<br>
          The button is activated by checking the delete checkboxes in the list.
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> Filter/Attribute
        </div>
        <div class="manual-explain">
          Filters the data displayed in the exhibit detail list.<br>
          *Filtering targets: ID, Name, Attribute (filtering by dropdown)
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> Exhibit Detail List
        </div>
        <div class="manual-explain">
          Displays a list of registered exhibit detail information.<br>
          Click the edit icon to display the edit screen.<br>
        </div>

      </mat-card-content>
    </mat-card>

  </div>
</div>
